/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    UpcomingShowCloseSendItemRequest,
} from '../models';

export interface UpcomingShowSendItemApiControllerRejectSendItemRequest {
    upcomingShowId: string;
    id: string;
    upcomingShowCloseSendItemRequest: UpcomingShowCloseSendItemRequest;
}

/**
 * 
 */
export class UpcomingShowSendItemApi extends runtime.BaseAPI {

    /**
     */
    async upcomingShowSendItemApiControllerRejectSendItemRaw(requestParameters: UpcomingShowSendItemApiControllerRejectSendItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling upcomingShowSendItemApiControllerRejectSendItem.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling upcomingShowSendItemApiControllerRejectSendItem.');
        }

        if (requestParameters.upcomingShowCloseSendItemRequest === null || requestParameters.upcomingShowCloseSendItemRequest === undefined) {
            throw new runtime.RequiredError('upcomingShowCloseSendItemRequest','Required parameter requestParameters.upcomingShowCloseSendItemRequest was null or undefined when calling upcomingShowSendItemApiControllerRejectSendItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/send-items/{id}:reject`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.upcomingShowCloseSendItemRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async upcomingShowSendItemApiControllerRejectSendItem(requestParameters: UpcomingShowSendItemApiControllerRejectSendItemRequest): Promise<void> {
        await this.upcomingShowSendItemApiControllerRejectSendItemRaw(requestParameters);
    }

}
